module.exports = __webpack_public_path__ + "static/media/signature.040b1f53.png";